
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 95","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 3.222v71.53c-14.083 4.8-18.38 6.813-26.674 6.813-14.022 0-19.33-6.812-33.326-6.812-4.598 0-8.17.766-11.429 1.746V62.874c3.26-.98 6.83-1.746 11.429-1.746 14.002 0 19.31 6.812 33.326 6.812 4.553 0 7.946-.638 12.388-1.98V21.68c-4.442 1.34-7.835 1.979-12.388 1.979-14.022 0-19.33-6.813-33.326-6.813-11.34 0-16.719 4.386-25.714 6.11v65.422c0 3.768-3.199 6.812-7.143 6.812S0 92.146 0 88.378V6.436c0-3.57 3.199-6.62 6.942-6.62 3.743 0 7.344 3.05 7.344 6.62v2.887C23.28 7.613 28.66 3.222 40 3.222c14.002 0 19.31 6.812 33.326 6.812 8.303 0 12.59-2.014 26.674-6.812z","fill":"currentColor"}})])
          )
        }
      }
    